import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { currencyString } from "@qgiv/core-js";
import { FormikSelect } from "@qgiv/core-donor";
import { useDispatch } from "react-redux";

const ShippingMethodOptions = ({ currency, shipping_methods }) =>
    shipping_methods.map(({ cost, id, name, method }) => (
        <option key={id} value={id}>
            {`${name} ${method && `(${method})`} - ${currencyString(cost, currency)}`}
        </option>
    ));

const ShippingMethod = ({
    currency,
    defaultCountry,
    displayShippingMethod = false,
    shippingMethodLabel = "Choose Shipping Method",
    Shipping_Address_Use_Mailing,
    Shipping_Method = "",
    shipping_methods = [],
    setFieldValue = () => {},
    storeCart,
    updateRegistrationShippingMethod = () => {},
    updateRegistrationTotals = () => {},
}) => {
    const dispatch = useDispatch();
    const currentShippingCost = shipping_methods.find(
        (item) => item.id === Number(Shipping_Method),
    );

    useEffect(() => {
        // Only set default country if user is not using the mailing address
        if (!Shipping_Address_Use_Mailing) {
            setFieldValue("Shipping_Country", defaultCountry);
        } else {
            setFieldValue("Shipping_Country", "");
        }
        // Pre-select shipping method if there is only one available
        if (shipping_methods.length === 1) {
            setFieldValue("Shipping_Method", `${shipping_methods[0].id}`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Shipping_Address_Use_Mailing]);

    useEffect(() => {
        dispatch(
            updateRegistrationShippingMethod(
                storeCart.length > 0 ? Shipping_Method : "",
            ),
        );
        dispatch(
            updateRegistrationTotals({
                totals: {
                    shippingMethodAmount:
                        storeCart.length > 0 &&
                        Shipping_Method &&
                        currentShippingCost
                            ? currentShippingCost.cost
                            : 0.0,
                },
            }),
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Shipping_Method, currentShippingCost, storeCart]);

    return (
        displayShippingMethod && (
            <div className="grid">
                <div className="col col--12 col--sm-8">
                    <FormikSelect
                        id="Shipping-Method"
                        name="Shipping_Method"
                        label={shippingMethodLabel}
                        type="select"
                        ariaRequired="true"
                    >
                        <ShippingMethodOptions
                            shipping_methods={shipping_methods}
                            currency={currency}
                        />
                    </FormikSelect>
                </div>
            </div>
        )
    );
};

ShippingMethod.propTypes = {
    currency: PropTypes.shape({}).isRequired,
    // Default country that is set in event settings
    defaultCountry: PropTypes.string.isRequired,
    // Flag that determines whether this field is displayed
    displayShippingMethod: PropTypes.bool.isRequired,
    // CMS customizable label for shipping methods field
    shippingMethodLabel: PropTypes.string.isRequired,
    // Formik value selected for Shipping Address Use Mailing field
    Shipping_Address_Use_Mailing: PropTypes.bool.isRequired,
    // Formik value selected for Shipping Options field
    Shipping_Method: PropTypes.string,
    // Array of objects that contain all the shipping options data
    shipping_methods: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    // Formik Function to set field values
    setFieldValue: PropTypes.func.isRequired,
    // Array of products added to cart
    storeCart: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    // Redux action to update the shipping method
    updateRegistrationShippingMethod: PropTypes.func.isRequired,
    // Redux action to update all summary totals
    updateRegistrationTotals: PropTypes.func.isRequired,
};

export default ShippingMethod;
